<template>
  <v-row class="mb-4">
    <v-col cols="12" md="4">
      <v-card
        class="pa-3 h-100"
        variant="outlined"
        @click="$router.push('/clients')"
        style="cursor: pointer;"
      >
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="primary">mdi-folder-account</v-icon>
          {{ t.dashboard?.clients_card || 'Clients' }}
        </v-card-title>
        <v-card-subtitle>{{ t.dashboard?.clients_card_desc || 'Manage clients and subclients' }}</v-card-subtitle>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <v-card
        class="pa-3 h-100"
        variant="outlined"
        @click="$router.push('/users')"
        style="cursor: pointer;"
      >
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="success">mdi-account-group</v-icon>
          {{ t.dashboard?.users_card || 'Users' }}
        </v-card-title>
        <v-card-subtitle>{{ t.dashboard?.users_card_desc || 'Manage users' }}</v-card-subtitle>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <v-card
        class="pa-3 h-100"
        variant="outlined"
        @click="$router.push('/services')"
        style="cursor: pointer;"
      >
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2" color="warning">mdi-cog</v-icon>
          {{ t.dashboard?.services_card || 'Services' }}
        </v-card-title>
        <v-card-subtitle>{{ t.dashboard?.services_card_desc || 'Manage available services' }}</v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'

export default {
  name: 'NavigationCardsSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  computed: {
    t() { return tRef.value }
  }
}
</script>
